import { GOOGLE_LIBRARY_LOADED } from 'base/actions/actionTypes';

export const setGoogleLoaded = () => {
  return {
    type: GOOGLE_LIBRARY_LOADED
  };
};
